export function decodeHTML<T extends string | null | undefined>(input: T): T {
	if (input == null) {
		return input;
	}

	// We use a TextArea because it uses the browser to render text, without rendering elements.
	// So <span>&&#xE6</span> becomes <span>æ</span>
	// Other elements would have the span become an actual span!
	const textarea = document.createElement('textarea');
	textarea.innerHTML = input;

	// We have to cast it to any because typescript does not understand that string
	// conforms to T (which is always string after the null guard)

	const value: any = textarea.value;

	return value;
}
